<template>
  <div class="d-flex justify-center">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon class="primary--text" v-on="on" v-bind="attrs" @click="detailsModalOpen = true">
          mdi-eye
        </v-icon>
      </template>
      <span>View Payload</span>
    </v-tooltip>

    <v-dialog v-model="detailsModalOpen" width="800" scrollable>
      <v-card>
        <v-card-title class="details-header d-flex align-center">
          <span>CODECO Event Payload</span>
          <v-spacer />
          <v-icon color="#fff" @click="detailsModalOpen = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="details-subheader px-4 py-2">
            <span class="text-body-1">{{ params.data.event }}</span>
            <span class="caption grey--text ml-2">{{ params.data.ts }}</span>
          </div>
          <div class="pa-4">
            <div class="body-box d-flex align-center justify-space-between px-3 py-2">
              <strong>Payload</strong>
              <v-icon small @click="copyToClipboard">mdi-content-copy</v-icon>
            </div>
            <div class="body-content pa-3">
              <vue-json-pretty :data="params.data.payload" />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="detailsModalOpen = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      detailsModalOpen: false,
    };
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(JSON.stringify(this.params.data.payload, null, 2));
      this.$bus.$emit("showToastMessage", {
        message: "Copied to clipboard",
        color: "success",
      });
    },
  },
};
</script>

<style scoped>
.details-header {
  background-color: #f07025;
  color: #fff;
}

.details-subheader {
  background-color: #eef7ee;
}

.body-box {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-bottom: none;
}

.body-content {
  max-height: 450px;
  overflow: auto;
  border: 1px solid #e0e0e0;
  margin: 0;
  background-color: #fff;
}
</style>
